<table mat-table [dataSource]="mailRuleList" class="mail-rule-table"
    *ngIf="mailRuleList?.data?.length > 0; else noDataTemplate">
    <ng-container matColumnDef="fromMail">
        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
            From Email
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            {{ element?.fromMail }}
            <!-- <div style="max-width: 100px;">
            </div> -->
        </td>
    </ng-container>

    <ng-container matColumnDef="fromName">
        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
            From Name
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            {{ element?.fromName }}
        </td>
    </ng-container>
    <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
            Subject
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            {{ element?.subject }}
        </td>
    </ng-container>

    <ng-container matColumnDef="moveToMail">
        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
            Move To
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            {{ element?.moveToName }}
        </td>
    </ng-container>

    <ng-container matColumnDef="fromDate">
        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
            From Date
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            {{ element?.startDate | date: 'dd/MM/yyyy' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="toDate">
        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
            To Date
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            {{ element?.endDate | date: 'dd/MM/yyyy' }}
        </td>
    </ng-container>
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="text-center no-whitespace">
            Action
        </th>
        <td mat-cell *matCellDef="let element" class="fw-semibold text-start cursuer">
            <button mat-button matTooltip="Edit Rule" (click)="editRule(element)">
                <i class="flaticon-edit"></i>
            </button>
            <button mat-button matTooltip="Remove Rule" (click)="deleteRule(element)">
                <i class="flaticon-close"></i>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<ng-template #noDataTemplate>
    <div class="mail-rule-table d-flex align-items-center justify-content-center">
        <p class="fs-18">No records found</p>
    </div>
</ng-template>